module.exports = __webpack_public_path__ + "img/82c0a01.png";